export const getDataFromStrapi = async (url: string) => {
	const isBrowser = typeof window !== "undefined";
	const baseUrl = isBrowser
		? process.env.NEXT_PUBLIC_STRAPI_BASE_URL
		: process.env.STRAPI_BASE_URL;
	const token = !isBrowser ? process.env.STRAPI_API_TOKEN : undefined;
	if (!baseUrl) {
		if (!isBrowser) {
			throw new Error("STRAPI_BASE_URL is not set");
		}
		console.log("NEXT_PUBLIC_STRAPI_BASE_URL is not set");
		return { data: [] };
	}
	try {
		const response = await fetch(baseUrl + url, {
			headers: token ? { Authorization: `Bearer ${token}` } : undefined,
		});
		if (!response.ok) {
			console.log("Strapi request failed", response.status, response.statusText);
			return { data: [] };
		}
		const data = await response.json();
		if (!data?.data) {
			return { data: [] };
		}
		return data;
	} catch (error) {
		console.log(error);
		return { data: [] };
	}
};
